import { useCallback } from 'react';
import { useSearchParams } from 'react-router';
import { TRADE_INTENT_PARAMS } from '@/constants';
import { TRADE_INTENT_PARAM_KEYS } from '@/utils';

export function useTradeIntent() {
	const [searchParams, setSearchParams] = useSearchParams();

	const clearTradeIntent = useCallback(() => {
		setSearchParams(
			(prev) => {
				const next = new URLSearchParams(prev);
				TRADE_INTENT_PARAM_KEYS.forEach((key) => next.delete(key));
				return next;
			},
			{ replace: true }
		);
	}, [setSearchParams]);

	return {
		marketId: searchParams.get(TRADE_INTENT_PARAMS.MARKET_ID),
		position: searchParams.get(TRADE_INTENT_PARAMS.POSITION),
		pickMatchId: searchParams.get(TRADE_INTENT_PARAMS.PICK_MATCH_ID),
		clearTradeIntent,
	};
}
